import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/sprint";

export default {
    /** 分页查询迭代批次 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 所属项目下拉选项 */
    queryProjectOptions: () => axios.get({url: `${PREFIX_URI}/queryProjectOptions`}),
    /** 保存迭代批次（新增/编辑） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除迭代批次（任务解绑批次） */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
};
